<template>
  <div class="detail" :class="[ getTerminalForChrome() ? 'detail-mo': 'detail-pc']">
    <!-- <div class="top"></div> -->
    <div class="title">{{detailMsg.caucustitle || detailMsg.consultationtitle || detailMsg.rulestitle || detailMsg.surveytitle}}</div>
    <div class="content" v-html="detailMsg.content"></div>
    <!-- <div class="date">{{detailMsg.rec_createdtime_str}}</div> -->
    <!-- <div class="back" v-if="getTerminalForChrome()">
      <Button @click="goBack">返回</Button>
    </div> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import  { getArticle } from '@/api/school'
import bus from './common/bus'
export default {
  data () {
    return {
      detailMsg: {}
    }
  },
  methods: {
    ...mapGetters(['getTerminalForChrome']),
    goBack() {
      this.$router.go(-1)
    },
    _getArticle(params) {
      getArticle({...params}).then(res => {
        if (res.status === 200) {
          this.detailMsg = res.data.data
        }
      })
    }
  },
  mounted() {
    this._getArticle({...this.$route.query})
    // console.log('busss', JSON.parse(sessionStorage.getItem('detailMsg')))
    // this.detailMsg = JSON.parse(sessionStorage.getItem('detailMsg'))

  }
}
</script>

<style scoped lang="scss">
.detail-pc {
  padding: 10px;
  .title {
    font-size: 22px;
    font-weight: 600;
    text-align: center;
    color: rgba(0, 0, 0, .9);
  }
  .content {
    margin: 30px 0px;
    img {
      border-style: none;
      height: auto !important;
      max-width: 100%;
    }
  }
  .date {
    font-size: 24px;
    text-align: right;
  }
}
.detail-mo {
  padding: 2.67vw;
  .title {
    font-size: 4.8vw;
    text-align: center;
    font-weight: 700;
    color: rgba(0,0,0,.9);
  }
  .content {
    margin: 2.13vw 0vw;
  }
  .date {
    font-size: 4.8vw;
    text-align: right;
    color: rgba(0,0,0,.9);
  }
  .back {
    text-align: center;
  }
}
</style>
